import { render, staticRenderFns } from "./add_custom_vanables.vue?vue&type=template&id=e9a002ca&scoped=true&"
import script from "./add_custom_vanables.vue?vue&type=script&lang=js&"
export * from "./add_custom_vanables.vue?vue&type=script&lang=js&"
import style0 from "./add_custom_vanables.vue?vue&type=style&index=0&id=e9a002ca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a002ca",
  null
  
)

export default component.exports